// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

const LookUpMemberNumber = dynamic(() => import('./LookUpMemberNumber').then(mod => mod.LookUpMemberNumber));

const LookUpMemberNumberConfig = {
  emptyLabel: 'LookUpMemberNumber',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/lookupmembernumber`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LookUpMemberNumberEditable = (props: any) => {
  return (
    <EditableComponent config={LookUpMemberNumberConfig} {...props}>
      <LookUpMemberNumber {...props} />
    </EditableComponent>
  );
};
